import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/layouts/ApiLayout.js";
import { graphql } from 'gatsby';
import Callout from '../../components/Callout';
import ComponentApi from '../../components/ComponentApi';
import ReactPlayground from '../../components/ReactPlayground';
import Basic from '../../examples/Offcanvas/Basic';
import Backdrop from '../../examples/Offcanvas/Backdrop';
import Placement from '../../examples/Offcanvas/Placement';
export const query = graphql`
  query OffcanvasQuery {
    Offcanvas: componentMetadata(displayName: { eq: "Offcanvas" }) {
      displayName
      ...ComponentApi_metadata
    }
    OffcanvasHeader: componentMetadata(displayName: { eq: "OffcanvasHeader" }) {
      ...ComponentApi_metadata
    }
    OffcanvasTitle: componentMetadata(displayName: { eq: "OffcanvasTitle" }) {
      ...ComponentApi_metadata
    }
    OffcanvasBody: componentMetadata(displayName: { eq: "OffcanvasBody" }) {
      ...ComponentApi_metadata
    }
  }
`;
export const _frontmatter = {};
const layoutProps = {
  query,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <h1 {...{
      "id": "offcanvas"
    }}>{`Offcanvas`}</h1>
    <p className="lead">
  Build hidden sidebars into your project for navigation, shopping carts, and
  more.
    </p>
    <h2 {...{
      "id": "examples"
    }}>{`Examples`}</h2>
    <p>{`Offcanvas includes support for a header with a close button and an optional body class
for some initial padding. We suggest that you include offcanvas headers with dismiss
actions whenever possible, or provide an explicit dismiss action.`}</p>
    <h3 {...{
      "id": "basic-example"
    }}>{`Basic Example`}</h3>
    <ReactPlayground codeText={Basic} mdxType="ReactPlayground" />
    <h3 {...{
      "id": "placement"
    }}>{`Placement`}</h3>
    <p>{`Offcanvas supports a few different placements:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`start`}</inlineCode>{` places offcanvas on the left of the viewport`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`end`}</inlineCode>{` places offcanvas on the right of the viewport`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`bottom`}</inlineCode>{` places offcanvas on the bottom of the viewport`}</li>
    </ul>
    <ReactPlayground codeText={Placement} mdxType="ReactPlayground" />
    <h3 {...{
      "id": "backdrop"
    }}>{`Backdrop`}</h3>
    <p>{`Scrolling the `}<inlineCode parentName="p">{`<body>`}</inlineCode>{` element is disabled when an offcanvas and its backdrop are
visible. Use the `}<inlineCode parentName="p">{`scroll`}</inlineCode>{` prop to toggle `}<inlineCode parentName="p">{`<body>`}</inlineCode>{` scrolling and the `}<inlineCode parentName="p">{`backdrop`}</inlineCode>{` prop
to toggle the backdrop.`}</p>
    <ReactPlayground codeText={Backdrop} mdxType="ReactPlayground" />
    <h2 {...{
      "id": "api"
    }}>{`API`}</h2>
    <ComponentApi metadata={props.data.Offcanvas} mdxType="ComponentApi" />
    <ComponentApi metadata={props.data.OffcanvasHeader} mdxType="ComponentApi" />
    <ComponentApi metadata={props.data.OffcanvasTitle} mdxType="ComponentApi" />
    <ComponentApi metadata={props.data.OffcanvasBody} mdxType="ComponentApi" />

    <p>{`;`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      